module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Light.ee2720729843e822714223d94ab30111.ttf";